import { j as e } from "./index.es33.js";
import { t as m } from "./index.es106.js";
import { Typography as p } from "./index.es35.js";
import "./index.es36.js";
import { PaginatorButton as i } from "./index.es569.js";
import t from "./index.es570.js";
var c = [25, 50, 100, 200],
  j = function j(_ref) {
    var o = _ref.perPage,
      s = _ref.onSelect,
      _ref$options = _ref.options,
      a = _ref$options === void 0 ? c : _ref$options;
    var n = Array.from(new Set(a));
    return e.jsxs("div", {
      className: t.stepChangeContainer,
      children: [e.jsxs(p.Body2, {
        className: t.text,
        as: "span",
        children: [m("component_component_paginatorStepChangerLabel_perPageLabel"), ":"]
      }), n.map(function (r) {
        return e.jsx(i, {
          onClick: function onClick() {
            return s === null || s === void 0 ? void 0 : s(r);
          },
          isDisabled: r === o,
          children: r
        }, r);
      })]
    });
  };
export { j as StepChanger };